export const MOCK_REWARDS = {
    challenges: [
        {
            title: 'Win 50 Blitz Games',
            achievement: {
                id: 1,
            },
            threshold: 50,
            progress: 0,
            tooltip: 'Start playing blitz games to begin this challenge.',
            description: 'Play and win 50 blitz games. Fast thinking, fast moves.',
            assetUrl: 'https://d1svqoq0y28r2z.cloudfront.net/rewards/play_puzzles/puzzle-reward-disabled.webp',
            endDate: '2025-01-01T00:00:00Z-07:00',
        },
        {
            title: 'Solve 100 Puzzles',
            achievement: {
                id: 2,
            },
            threshold: 100,
            progress: 30,
            tooltip: "You've solved 30 out of 100 puzzles.",
            description: 'Train your tactics by solving 100 chess puzzles.',
            assetUrl: 'https://d1svqoq0y28r2z.cloudfront.net/rewards/play_puzzles/puzzle-reward-disabled.webp',
            endDate: '2025-01-01T00:00:00Z-07:00',
        },
        {
            title: 'Win 20 Bullet Games',
            achievement: {
                id: 3,
            },
            threshold: 20,
            progress: 19,
            tooltip: "You're almost there — one more bullet win to go!",
            description: 'Win 20 ultra-fast bullet chess games.',
            assetUrl: 'https://d1svqoq0y28r2z.cloudfront.net/rewards/play_puzzles/puzzle-reward-disabled.webp',
            endDate: '2025-01-01T00:00:00Z-07:00',
        },
        {
            title: 'Reach 1500 Blitz Rating',
            achievement: {
                id: 4,
            },
            threshold: 1500,
            progress: 1500,
            tooltip: "You've reached the 1500 blitz rating milestone!",
            description: 'Achieve a 1500 blitz rating to complete this challenge.',
            assetUrl: 'https://d1svqoq0y28r2z.cloudfront.net/rewards/bots/bot-reward-active.webp',
            endDate: '2025-01-01T00:00:00Z-07:00',
        },
        {
            title: 'Play 30 Daily Games',
            achievement: {
                id: 5,
            },
            threshold: 30,
            progress: 25,
            tooltip: 'Expired — only 5 games short!',
            description: 'Complete 30 daily (correspondence) games before the challenge expires.',
            assetUrl: 'https://d1svqoq0y28r2z.cloudfront.net/rewards/play_puzzles/puzzle-reward-disabled.webp',
            endDate: '2024-01-01T00:00:00Z-07:00',
        },
    ],
    achievements: [
        {
            challenge: {
                id: 1,
            },
            title: 'Blitz Beginner',
            categoryName: 'Speed Chess',
            counter: 0,
            tooltip: 'You haven’t started this blitz challenge yet.',
            description: 'Earned by winning 50 blitz games.',
            assetUrl: 'https://example.com/assets/achievements/blitz_beginner_badge.png',
            expirationDate: '2025-01-01T00:00:00Z-07:00',
        },
        {
            challenge: {
                id: 2,
            },
            title: 'Tactics Trainer',
            categoryName: 'Training',
            counter: 30,
            tooltip: 'Solve 70 more puzzles to earn this badge.',
            description: 'Awarded for solving 100 puzzles.',
            assetUrl: 'https://example.com/assets/achievements/tactics_trainer.png',
            expirationDate: '2025-01-01T00:00:00Z-07:00',
        },
        {
            challenge: {
                id: 3,
            },
            title: 'Bullet Slayer',
            categoryName: 'Speed Chess',
            counter: 19,
            tooltip: 'Just one more bullet win!',
            description: 'Awarded for winning 20 bullet games.',
            assetUrl: 'https://example.com/assets/achievements/bullet_slayer.png',
            expirationDate: '2025-01-01T00:00:00Z-07:00',
        },
        {
            challenge: {
                id: 4,
            },
            title: 'Blitz Climber',
            categoryName: 'Ratings',
            counter: 1500,
            tooltip: "You've reached the goal rating!",
            description: 'Achieve a blitz rating of 1500.',
            assetUrl: 'https://example.com/assets/achievements/blitz_climber.png',
            expirationDate: '2025-01-01T00:00:00Z-07:00',
        },
        {
            challenge: {
                id: 5,
            },
            title: 'Daily Devotee',
            categoryName: 'Long Games',
            counter: 25,
            tooltip: 'Challenge expired before completion.',
            description: 'Complete 30 daily games. The deadline has passed.',
            assetUrl: 'https://example.com/assets/achievements/daily_devotee_expired.png',
            expirationDate: '2024-01-01T00:00:00Z-07:00',
        },
    ],
}
